module.exports = __webpack_public_path__ + "static/img/hx3.a322b65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/hx3.png
// module id = SOK3
// module chunks = 1